import Vue from 'vue';
import api from '@/services/api';
import { Module } from 'vuex';
import { RootState } from '@/types';
import _ from 'underscore';

export interface Contact {
  firstName?: string;
  lastName?: string;
  title?: string;
  email?: string;
  phone?: string;
}

export interface NamedContact extends Contact {
  duties: string[];
}

export interface ContactState {
  doug?: NamedContact;
  ryan?: NamedContact;
  mayra?: NamedContact;
  susan?: NamedContact;
  contacts: Contact[];
}

export const ContactStore: Module<ContactState, RootState> = {
  namespaced: true,

  state: {
    doug: undefined,
    ryan: undefined,
    mayra: undefined,
    susan: undefined,
    contacts: []
  },

  getters: {
    doug: (state) => state.doug,
    ryan: (state) => state.ryan,
    mayra: (state) => state.mayra,
    susan: (state) => state.susan,
    contacts: (state) =>
      _(state.contacts)
        .chain()
        .sortBy((c) => c.firstName)
        .sortBy((c) => c.lastName)
        .value()
  },

  mutations: {
    setState: (state, s: ContactState) => {
      state.doug = s.doug;
      state.ryan = s.ryan;

      state.mayra = s.mayra;
      // The elements within an array are not reactive
      // so we have to essentially force Vue to recognize
      // that the array has changed
      (state.mayra as any).length = 0;
      Vue.set(state.mayra as any, 'duties', (s.mayra || {} ).duties || []);

      state.susan = s.susan;
      (state.susan as any).length = 0;
      Vue.set(state.susan as any, 'duties', (s.susan || {} ).duties || []);

      state.contacts = s.contacts;
    }
  },

  actions: {
    async loadContacts({ commit }) {
      try {
        const { data } = await api().get('contacts.json');
        commit('setState', data as ContactState);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
